import { getAuthClient } from "@trumpf/ux.utils";
import { authClientName } from "../config";
export class ApiClient {
    constructor(config) {
        this.token = null;
        this.authClientServiceCalls = getAuthClient(authClientName);
        this.config = config;
        this.token = this.authClientServiceCalls.getAccessToken();
        if (this.token) {
            this.onAuth();
        }
        else {
            this.authClientServiceCalls.subscribe((token) => {
                this.token = token || null;
                this.onAuth();
            });
        }
    }
    onAuth() {
        // placeholder for any action to be taken on authentication
    }
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        if (!this.token) {
            return Promise.reject("No token");
        }
        const { method = "POST", headers = {}, body, binary } = options || {};
        const response = await fetch(`${path}`, {
            method,
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${this.token}` }, headers),
            body: binary
                ? body
                : JSON.stringify(Object.assign({}, body))
        });
        if (response.status === 200) {
            if ((options === null || options === void 0 ? void 0 : options.responseType) === "blob") {
                return response.blob();
            }
            return response.json();
        }
        return Promise.reject(`Error ${response.status}`);
    }
    async mockRequest(mockResponse) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockResponse);
            }, 1000);
        });
    }
}
//# sourceMappingURL=apiClient.js.map
